import { FormControl, TextField } from "@mui/material";
import { default as React, useEffect } from "react";
import { Theme, createStyles, makeStyles } from "@material-ui/core/styles";

const useStyles = makeStyles((theme: Theme) =>
  createStyles({
    formControl: {
      margin: theme.spacing(1),
      marginLeft: 0,
      marginRight: 0,
      width: "100%",
    },
  })
);

export interface Form0x49800000 {
  debugLevel: number;
}

export function Command0x49800000(props) {
  const classes = useStyles();
  const { value, handleChange } = props;

  const commandForm = {
    debugLevel: 0,
  };

  const [fields, setFields] = React.useState<Form0x49800000>(commandForm);

  const handleChangeField =
    (prop: keyof Form0x49800000) =>
    (event: React.ChangeEvent<HTMLInputElement>) => {
      handleChange(JSON.stringify({ ...fields, [prop]: event.target.value }));
    };

  useEffect(() => {
    const params = JSON.parse(value);

    if (!params.debugLevel) {
      params.debugLevel = 0;
    }

    setFields(params);
  }, [value]);

  return (
    <>
      <FormControl className={classes.formControl}>
        <TextField
          type="number"
          // inputProps={{ min: 0, max: 5 }}
          id="debugLevel"
          label="Режим отладки"
          margin="dense"
          fullWidth
          value={fields.debugLevel}
          onChange={handleChangeField("debugLevel")}
          helperText="0-нет отладки, 1-5 варианты"
        />
      </FormControl>
    </>
  );
}
